import React from 'react';
import tw from 'twin.macro';
import { Menu } from '@teetsh/app/src/components/Menu';
import Link from '@teetsh/app/src/components/Link';
import { BreadcrumbItemProps } from '@teetsh/app/src/components/Breadcrumb';
import { useIsBelowBreakpoint } from '@teetsh/app/src/components/ResponsiveSwitcher/useIsBelowSize';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

interface Props {
  item: BreadcrumbItemProps;
}

const titleStyle = tw`text-neutral-intense`;
export function BreadcrumbSubItem(props: Props) {
  const { item } = props;
  const isMobile = useIsBelowBreakpoint('md');
  if (item.isLoading) {
    return (
      <div className="tsh-skeleton">
        <span tw="invisible">CHARGEMENT</span>
      </div>
    );
  }

  const text = isMobile && item.mobileText ? item.mobileText : item.text;
  const SubItem = item.subItemComponent;
  const itemStyle = [titleStyle, item.style];

  if (item.items || SubItem) {
    return (
      <Menu fill large>
        <Menu.Button
          outlined
          css={itemStyle}
          fill
          aria-label={item.buttonAriaLabel}
          rightIcon={ChevronDownIcon}
        >
          {item.iconElement}
          <span tw="truncate">{text}</span>
        </Menu.Button>
        <Menu.Items>
          {(item.items || []).map(subitem => (
            <Menu.Item
              key={subitem.id}
              icon={subitem.icon}
              onClick={subitem.onClick}
              to={subitem.to}
              text={subitem.text}
            />
          ))}
          {SubItem && <SubItem />}
        </Menu.Items>
      </Menu>
    );
  }
  if (item.to) {
    return (
      <Link
        to={item.to}
        css={[...itemStyle, tw`truncate block hover:text-brand-intense`]}
      >
        {text}
      </Link>
    );
  }
  return <div css={itemStyle}>{text}</div>;
}
